import { render, staticRenderFns } from "./addCommunicationDetailModal.vue?vue&type=template&id=9c189844&"
import script from "./addCommunicationDetailModal.vue?vue&type=script&lang=js&"
export * from "./addCommunicationDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports